import { Dialog } from "./Dialog";
import { Tenant, TenantPicker } from "./TenantPicker";

type TenantPickerDialogProps = {
  open: boolean;
  onClose: () => void;
  onTenantSelected: (tenant: Tenant) => void;
};

export function TenantPickerDialog({ open, onClose, onTenantSelected }: TenantPickerDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      title="Change Organizations"
      noPrimaryAction
    >
      <TenantPicker onTenantSelected={onTenantSelected} />
    </Dialog>
  );
}
